/**
 * Known ROS message types for rosbridge subscriptions.
 * Supplying these avoids roslib `getTopicType` → `rosapi/topic_type` service calls
 * (each spawns a thread when rosbridge `call_services_in_new_thread` is enabled).
 */
export const ROS_TOPIC_MESSAGE_TYPES = {
    "/state/battery": "std_msgs/Int32",
    "/state/mode": "std_msgs/String",
    "/docking/state": "std_msgs/Bool",
    "/docking/charge_status": "std_msgs/String",
    "/state/motor": "std_msgs/String",
    "/state/modes": "std_msgs/String",
    "/state/height": "std_msgs/Float32",
    "/map/compressed": "sensor_msgs/CompressedImage",
    "/map_metadata": "nav_msgs/MapMetaData",
    "/robot_pose": "geometry_msgs/PoseStamped",
    "/plan_smoothed": "nav_msgs/Path",
    "/plan": "nav_msgs/Path",
    "/navigate_to_pose/_action/status": "action_msgs/GoalStatusArray",
    "/navigate_to_pose_stage": "std_msgs/String",
    "/mission_executor/state": "mission_executor_interfaces/msg/MissionExecutorState",
    "/system_status": "slamware_ros_sdk/SystemStatus",
    "/arc/state/battery_level": "std_msgs/Float32",
    "/hardware/gps": "std_msgs/String",
    "/hardware/spot_light": "std_msgs/String",
    "/hardware/security_module": "std_msgs/String",
    "/perform/movement": "geometry_msgs/Twist",
    "/camera/health": "std_msgs/String",
    "/gimbal/health/video": "std_msgs/String",
    "/gimbal/health/control": "std_msgs/String",
    "/gimbal/status": "std_msgs/String",
    "/gimbal/status/angle": "geometry_msgs/Vector3",
    "/gimbal/zoom": "std_msgs/Int32",
    "/gimbal/absolute_zoom": "std_msgs/Float32",
    "/gimbal/manual_focus": "std_msgs/Int32",
    "/gimbal/touch_focus": "geometry_msgs/Point",
    "/aurora/conf_xyz": "std_msgs/String",
    "/r2c2_360/state": "std_msgs/String",
};

/** @param {string} topic */
export const rosTopicMessageType = (topic) => ROS_TOPIC_MESSAGE_TYPES[topic] ?? "";
